module.exports = "<form class=\"search\">\n    <label for=\"search_input\">\n      <input #globalSearchBox name=\"globalSearchBox\" [(ngModel)]=\"searchTerm\" id=\"search_input\" type=\"text\" (keyup)=\"search(globalSearchBox.value)\" placeholder='{{placeholderText | translate}}'>\n    </label>\n</form>"


//////////////////
// WEBPACK FOOTER
// ./src/app/base/global-search/global-search.component.html
// module id = 855
// module chunks = 0